import { apiPost } from "./client";

export function postEmail(data) {
  return apiPost("/emails/", data);
}
